module.exports = __webpack_public_path__ + "media/images/official/voice_quotation_end-3b2e09c9716cc32d33f18d5d29016639.svg";